import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    >
        {children}
    </motion.div>
);

export const Overline = ({ children, centered = false }) => (
    <div
        className={`flex items-center gap-4 ${centered ? "justify-center" : ""}`}
    >
        <span className="h-px w-10 bg-gold/60" aria-hidden="true" />
        <span className="text-xs font-sans font-medium uppercase tracking-[0.35em] text-gold">
            {children}
        </span>
        {centered && (
            <span className="h-px w-10 bg-gold/60" aria-hidden="true" />
        )}
    </div>
);
